'use strict';

module.exports = /*@ngInject*/ function () {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            element.on('input', function () {
                scope[attrs.watchChange](this);
            })
        }
    };
};